export enum CriticalGeometryMessageType {
  RequestUpdate = 'physna:cg:request-update',
  UpdateState = 'physna:cg:update-state',
  GetReleaseVector = 'physna:cg:get-release-vector',
  ReleaseVector = 'physna:cg:release-vector',
  ReloadAnalysis = 'physna:cg:reload-analysis',
}

export type CriticalGeometryRequestUpdateMessage = {
  type: CriticalGeometryMessageType.RequestUpdate;
};

export type CriticalGeometryUpdateStateMessage = {
  type: CriticalGeometryMessageType.UpdateState;
  isUpdating: boolean;
};

export type CriticalGeometryGetReleaseVectorMessage = {
  type: CriticalGeometryMessageType.GetReleaseVector;
  requestId: string;
};

export type CriticalGeometryReleaseVectorMessage = {
  type: CriticalGeometryMessageType.ReleaseVector;
  requestId: string;
  releaseUnitVector?: unknown;
};

export type CriticalGeometryReloadAnalysisMessage = {
  type: CriticalGeometryMessageType.ReloadAnalysis;
};

export const isCriticalGeometryRequestUpdateMessage = (
  value: unknown
): value is CriticalGeometryRequestUpdateMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown };
  return message.type === CriticalGeometryMessageType.RequestUpdate;
};

export const isCriticalGeometryUpdateStateMessage = (value: unknown): value is CriticalGeometryUpdateStateMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown; isUpdating?: unknown };
  return message.type === CriticalGeometryMessageType.UpdateState && typeof message.isUpdating === 'boolean';
};

export const isCriticalGeometryReleaseVectorMessage = (
  value: unknown
): value is CriticalGeometryReleaseVectorMessage => {
  if (typeof value !== 'object' || value === null) return false;
  const message = value as { type?: unknown; requestId?: unknown };
  return message.type === CriticalGeometryMessageType.ReleaseVector && typeof message.requestId === 'string';
};
